import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { toFirebaseKey } from 'utils/utils'

import { api } from '../../../../api/integrationAPI'

const ProductSettings = ({ product, selectedOptions, selectOption, addToCart }) => {

  let { id, details } = product
  const price = api.getProductPrice(product, selectedOptions)
  const prevPrice = api.getProductPrevPrice(product, selectedOptions)
  const disabledOptions = api.getDisabledOptions(product, selectedOptions)
  const options = details.options

  const pc = 'in_product-card'

  if (!id) {
    id = product.productId
  }

  const optionIsActive = (name, v) => {
    if (disabledOptions[name] && disabledOptions[name].indexOf(v) >= 0) return false
    return true
  }

  const renderOption = (option) => {
    let changeStyle = false
    option.values.map(value => {
      const color = product.colorOptions && product.colorOptions[toFirebaseKey(value)] ? product.colorOptions[toFirebaseKey(value)] : null
      if (value.length > 4 && !color) {
        changeStyle = true
      }
    })
    return (
      <div key={option.id}>
        <div className={'in_product-card__settings-title'}>
          {option.name}
        </div>
        <div className={`in_product-card__settings ${changeStyle ? 'in_product-card__settings--wrap' : ''}`}>
          {option.values && option.values.map((v, index) => {
            const color = product.colorOptions && product.colorOptions[toFirebaseKey(v)] ? product.colorOptions[toFirebaseKey(v)] : null
            const colorStyle = color ? {backgroundColor: color} : {}
            const isActive = optionIsActive(option.name, v)
            const classes = cx(
                'in_product-card__setting-label',
            (changeStyle && 'in_product-card__setting-label--changed'),
            (selectedOptions && selectedOptions[option.name] === v) && 'in_product-card__setting-label--selected',
                !isActive && 'in_product-card__setting-label--disabled'
            )
            return (
              <label
                className={classes}
                key={index}
                onClick={() => {
                  if (isActive) selectOption(option.name, v)
                }}
              >
                <input type={'radio'} value={option.id} className={'in_product-card__setting-input'} />
                {color ? <span className='in_product-card__setting-color' style={colorStyle} /> : v}
              </label>
            )

          })}
          <span className={`in_product-card__setting-selector ${changeStyle ? 'in_product-card__setting-selector--hidden' : ''}`} />
        </div>
      </div>
    )
  }
  // console.log('result options', options, 'selectedOptions', selectedOptions, 'price', price)

  const renderPrevPrice = () => {
    if (prevPrice && prevPrice !== price) {
      return (
        <span className={`${pc}__prev_price`}>${prevPrice}</span>
      )
    }
  }

  return (
    <div className={`in_product-card__settings-block in_product_settings_${id}`}>
      <div id={`in_product_variants_${id}`} className={'in_product-card__variants-block'}>
        {options && options.map(renderOption)}
      </div>
      <button className={'in_product-card__add-to-cart-button'} disabled={!price} onClick={addToCart}>
        Add to Cart {renderPrevPrice()}{price && `$${price}`}
      </button>
      <button className={'in_product-card__save-button'}>Save</button>
    </div>
  )
}

ProductSettings.defaultProps = {
  selectOption: () => null,
  addToCart: () => null
}

ProductSettings.propTypes = {
  product: PropTypes.object.isRequired,
  selectedOptions: PropTypes.object,
  selectOption: PropTypes.func,
  addToCart: PropTypes.func
}

export default ProductSettings



// WEBPACK FOOTER //
// ./src/templates/insta/components/products/ProductSettings.js